import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

// Nested tags and keyFacts are resolved by their own discriminators; a missing one fails with "Unknown discriminator".
const buildMainSettingsBody = (
	integrationProvider: Api.IntegrationProvider,
	mainSettings: Partial<Api.IIntegrationSettings>
) => ({
	...mainSettings,
	...(mainSettings.tags ? { tags: { _type: `${integrationProvider}TagSettings`, ...mainSettings.tags } } : {}),
	...(mainSettings.keyFacts
		? { keyFacts: { _type: `${integrationProvider}KeyFactSettings`, ...mainSettings.keyFacts } }
		: {}),
	_type: `${integrationProvider}IntegrationSettings`,
});

export const usePostExternalIntegrationMainSettingsMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			integrationProvider,
			mainSettings,
		}: {
			integrationProvider: Api.IntegrationProvider;
			mainSettings: Partial<Api.IIntegrationSettings>;
		}) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/settings`,
				}),
				'POST',
				buildMainSettingsBody(integrationProvider, mainSettings)
			);
		},
		onError,
		onSuccess,
	});
};
